import API from "@http"
import Types from "@redux/types/auth/user-activation.type";
const isLoading = (dispatch) => {
    dispatch({
        type: Types.USER_ACTIVATION_REQUEST
    });
};

const isError = (dispatch, error) => {
    console.log(error.response?.data?.message)
    dispatch({
        type: Types.USER_ACTIVATION_ERROR,
        payload: {
            activationState: "error",
            statusMessage: error.response?.data?.message
        }
    });
};

export const CheckActivation = (activationCode) => async (dispatch, getState) => {
    isLoading(dispatch);
    try {
        const response = await API.post("/auth/validate_activation", {
            activationCode
        });
        
        dispatch({
            type: Types.USER_ACTIVATION_CHECK,
            payload: { data: response.data, activationState: "success" }
        });
    } catch (error) {
        console.log(error)
        isError(dispatch, error);
    }
};


export const ResendActivation = (activationCode) => async (dispatch, getState) => {
    isLoading(dispatch);
    try {
        const response = await API.post("/auth/resend_activation", {
            activationCode
        });

        dispatch({
            type: Types.USER_ACTIVATION_CHECK,
            payload: { activationState: "resend_success" }
        });
    } catch (error) {
        console.log(error)
        isError(dispatch, error);
    }
};
